import { NavigationCarousel } from '@/features/carousel';
import { DotsType } from '@/features/carousel/types';
import { generateImageAlt } from '@/app/(pdp)/_components/gallery/utils/generate-image-alt';
import { useGallaryItems } from '@/app/(pdp)/_components/gallery/utils/use-gallary-items';
import usePDPData from '@/app/(pdp)/_utils/use-pdp-data';
import { useVariantContextValues } from '@/app/(pdp)/context/use-variant-context-values';
import { PUBLIC_IS_BOT } from '@/app/_constants/search-engines';
import { cn } from '@/utils/cn';
import { handleImageError } from '@/utils/image-error';
interface Props {
  slug: string;
}
const Gallery = ({
  slug
}: Props) => {
  const {
    data: product
  } = usePDPData(slug);
  const {
    activeVariant
  } = useVariantContextValues('baby-pdp');
  const {
    images
  } = useGallaryItems('baby-pdp', slug);
  const count = images.length;
  if (!count) return null;
  return <div data-sentry-component="Gallery" data-sentry-source-file="gallery.tsx">
            <NavigationCarousel className={cn(count === 1 ? 'mx-auto my-0 !w-fit' : 'w-[316px]')} options={{
      perView: count === 1 ? 1 : 'auto',
      spacing: 0,
      mode: 'snap'
    }} dotsType={count > 1 ? DotsType.PDP : undefined} data-sentry-element="NavigationCarousel" data-sentry-source-file="gallery.tsx">
                {images.map(({
        imageUrl,
        id
      }, index) => imageUrl && <div key={id} className='keen-slider__slide !h-64 !min-h-[256px] !w-64 !min-w-[256px] overflow-visible p-1'>
                                <img src={`${imageUrl}?w=320`} alt={generateImageAlt(index, product, activeVariant || undefined)} onError={handleImageError} className='h-full w-full rounded shadow' loading={index !== 0 && !PUBLIC_IS_BOT ? 'lazy' : undefined} width='300' height='300' />
                            </div>)}
            </NavigationCarousel>
        </div>;
};
export default Gallery;